module.exports = {
  footerText: 'Copyright Community Compass © 2025',
};
